import React from 'react';
import FeedbackDetailBlock from '@/views/event_detail/FeedbackDetailBlock';
import {FeedbackEvent} from 'entities/event';

interface Props {
    eventData: FeedbackEvent;
}

const ChatTextSamplesModalContents = React.memo<Props>(({eventData}) => (
    <FeedbackDetailBlock eventData={eventData} />
));

export default ChatTextSamplesModalContents;
